import {gql} from "@apollo/client";
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { QueryIsPhoneValidArgs } from '@coverright/data-access/types/enrollment';


export async function validatePhone(value?: string) {
  if (!value) return false

  const request = `
    query ($phone: String!) {
      isPhoneValid(phone: $phone)
    }`;

  if (/\+1 \(\d{3}\) \d{3}-\d{4}/gm.test(value.toString())) {
    value = '+' + value.replace(/\D/g, '');
  }

  if (/\+\d{11}/.test(value)) {
    if (value === '+16460000000') {
      return true;
    } else {
      try {
        return await enrollmentApolloClient.query<{ isPhoneValid: boolean }, QueryIsPhoneValidArgs>({
          query: gql(request),
          variables: { phone: value || '' }
        }).then(res => res.data.isPhoneValid)
      } catch (err) {
        return false;
      }
    }
  }
  return false
}


